import React from "react";
import { Button } from "reactstrap";
import { ReactComponent as MsgIcon } from "../../images/svg_icons/message-white.svg";
import "./styles.scss";

const ContactFloatButton = ({ onClick }) => {
  return (
    <Button color="primary" className="contact-float-button" onClick={onClick}>
      Contact Agent
      <MsgIcon />
    </Button>
  );
};

export default ContactFloatButton;
